import React, { useRef } from "react";
import "./HomePage.css";
import MilestoneCircle from "./MilestoneCircle";
import "../../App.css";

const HomePage = () => {
  // 1) Create a ref to the Milestone Circle section
  const milestoneRef = useRef(null);

  // 2) Handler to scroll to the Milestone Circle
  const scrollToMilestone = () => {
    if (milestoneRef.current) {
      milestoneRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="home-page">
      {/* Hero / Header Section */}
      <header className="home-page-header">
        <div className="hero-content">
          <h1 className="company-title">Cycle IT</h1>
          <p className="tagline">Empower Your IT Journey</p>
        </div>
      </header>

      {/* Journey Introduction Section */}
      <section className="journey-section">
        <h2 className="slogan">
          <span className="slogan-animated">
            It’s Time to Start Your Journey
          </span>
        </h2>
        
        <p className="intro-text">
          Welcome to Cycle IT. We help you streamline your IT operations,
          manage software lifecycles, and optimize costs, so you can
          focus on what matters most—your business goals.
        </p>
        
        {/* 3) Attach the scroll handler to the button */}
        <button className="cta-button" onClick={scrollToMilestone}>
          Get Started
        </button>
      </section>

      {/* Milestone Circle Section */}
      <section className="milestone-section" ref={milestoneRef}>
        <MilestoneCircle />
      </section>
    </div>
  );
};

export default HomePage;
